function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref4 = /*#__PURE__*/React.createElement("title", null, "Shape 7");

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 4,
  d: "M1067,441.7 C1066.5,441.7,1066,441.6,1065.5,441.5 C1062.5,440.7,1060.8,437.6,1061.6,434.6 C1063.6,427.5,1064.5,420.1,1064.5,412.6 C1064.5,405.1,1063.5,397.7,1061.5,390.5 C1060.7,387.5,1062.4,384.5,1065.4,383.6 C1068.4,382.7,1071.4,384.5,1072.3,387.5 C1074.6,395.6,1075.7,404,1075.7,412.5 C1075.7,420.9,1074.6,429.4,1072.3,437.4 C1071.7,440.1,1069.4,441.7,1067,441.7"
}));

var _ref6 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#3"
});

var _ref7 = /*#__PURE__*/React.createElement("title", null, "Shape 8");

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 6,
  d: "M1084.5,459.5 C1083.8,459.5,1083.1,459.4,1082.4,459.1 C1079.5,458,1078.2,454.7,1079.3,451.8 C1084.3,439.4,1086.8,426.2,1086.8,412.7 C1086.8,399.2,1084.3,386,1079.3,373.6 C1078.2,370.7,1079.5,367.5,1082.4,366.3 C1085.3,365.2,1088.5,366.5,1089.7,369.4 C1095.2,383.2,1098,397.7,1098,412.7 C1098,427.7,1095.2,442.2,1089.7,456 C1088.8,458.2,1086.7,459.5,1084.5,459.5"
}));

var _ref9 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#5"
});

var _ref10 = /*#__PURE__*/React.createElement("title", null, "Shape 9");

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 8,
  d: "M1101.5,476.5 C1100.7,476.5,1099.9,476.3,1099.1,475.9 C1096.3,474.5,1095.2,471.2,1096.5,468.5 C1105,451.1,1109.3,432.3,1109.3,412.7 C1109.3,393.1,1105,374.3,1096.5,356.9 C1095.1,354.1,1096.3,350.8,1099.1,349.5 C1101.9,348.1,1105.2,349.3,1106.5,352.1 C1115.7,371.1,1120.5,391.5,1120.5,412.8 C1120.5,434.1,1115.8,454.5,1106.5,473.5 C1105.6,475.4,1103.6,476.5,1101.5,476.5"
}));

var _ref12 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#7"
});

var _ref13 = /*#__PURE__*/React.createElement("title", null, "Shape 10");

var _ref14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 10,
  d: "M363.8,307.2 C363.8,300.8,369,295.3,375.4,295.3 C382.2,295.3,387.3,300.8,387.3,307.2 C387.3,334.6,387.3,362,387.3,389.4 C397.7,372.3,414.2,358.6,441.4,358.6 C479.6,358.6,501.9,384.3,501.9,421.9 C501.9,451.133,501.9,480.367,501.9,509.6 C501.9,516.4,496.7,521.5,490.3,521.5 C483.6,521.5,478.4,516.3,478.4,509.6 C478.4,482.3,478.4,455,478.4,427.7 C478.4,398.4,462.5,380,434.7,380 C407.5,380,387.3,399.9,387.3,429.5 C387.3,456.2,387.3,482.9,387.3,509.6 C387.3,516.4,382.4,521.5,375.7,521.5 C369,521.5,363.8,516.3,363.8,509.6 C363.8,509.6,363.8,307.2,363.8,307.2 z"
}));

var _ref15 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#9"
});

var _ref16 = /*#__PURE__*/React.createElement("title", null, "Shape 11");

var _ref17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 12,
  d: "M638.9,461.9 C638.9,456.8,638.9,451.7,638.9,446.6 C627.3,443.2,611.7,439.8,592.4,439.8 C562.7,439.8,546.3,452.6,546.3,472.5 C546.3,472.7,546.3,472.9,546.3,473.1 C546.3,493,564.6,504.6,586,504.6 C615.1,504.7,638.9,487,638.9,461.9 M522.5,474.1 C522.5,473.9,522.5,473.7,522.5,473.5 C522.5,440.2,550,422.5,590,422.5 C610.1,422.5,624.6,425.3,638.6,429.3 C638.6,427.467,638.6,425.633,638.6,423.8 C638.6,395.4,621.2,380.7,591.6,380.7 C575.7,380.7,562.3,384.4,550.6,389.6 C549.1,390.2,547.6,390.5,546.3,390.5 C540.8,390.5,535.9,385.9,535.9,380.4 C535.9,375.5,539.3,371.8,542.3,370.6 C557.9,363.8,573.8,359.9,594,359.9 C616.3,359.9,633.5,365.7,645,377.3 C655.7,388,661.2,403.3,661.2,423.4 C661.2,452.233,661.2,481.067,661.2,509.9 C661.2,516.7,656.3,521.5,649.9,521.5 C643.2,521.5,638.6,516.6,638.6,510.5 C638.6,505.7,638.6,500.9,638.6,496.1 C627.6,510.5,609.3,523.3,581.4,523.3 C552.1,523.3,522.5,506.5,522.5,474.1"
}));

var _ref18 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#11"
});

var _ref19 = /*#__PURE__*/React.createElement("title", null, "Shape 12");

var _ref20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 14,
  d: "M687.5,372.4 C687.5,366,692.7,360.5,699.1,360.5 C705.8,360.5,711,365.7,711,372.4 C711,372.4,711,402,711,402 C722.6,375.7,745.6,359.8,765.4,359.8 C772.4,359.8,777,365,777,371.7 C777,378.1,772.7,382.7,766.6,383.6 C736,387.3,711,410.2,711,455.7 C711,473.633,711,491.567,711,509.5 C711,515.9,706.1,521.4,699.4,521.4 C692.7,521.4,687.5,516.2,687.5,509.5 C687.5,509.5,687.5,372.4,687.5,372.4 z"
}));

var _ref21 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#13"
});

var _ref22 = /*#__PURE__*/React.createElement("title", null, "Shape 13");

var _ref23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 16,
  d: "M797.6,307.2 C797.6,300.8,802.8,295.3,809.2,295.3 C815.9,295.3,821.1,300.8,821.1,307.2 C821.1,374.633,821.1,442.067,821.1,509.5 C821.1,516.3,816.2,521.4,809.5,521.4 C802.8,521.4,797.6,516.2,797.6,509.5 C797.6,509.5,797.6,307.2,797.6,307.2 z"
}));

var _ref24 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#15"
});

var _ref25 = /*#__PURE__*/React.createElement("title", null, "Shape 14");

var _ref26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 18,
  d: "M847.4,372.4 C847.4,366,852.6,360.5,859,360.5 C865.7,360.5,870.9,365.7,870.9,372.4 C870.9,418.133,870.9,463.867,870.9,509.6 C870.9,516.4,866,521.5,859.3,521.5 C852.6,521.5,847.4,516.3,847.4,509.6 C847.4,509.6,847.4,372.4,847.4,372.4 z M845.2,312.4 C845.2,304.7,851.3,299.9,858.9,299.9 C866.8,299.9,873,304.8,873,312.4 C873,313.733,873,315.067,873,316.4 C873,323.7,866.9,328.9,858.9,328.9 C851.2,328.9,845.2,323.7,845.2,316.4 C845.2,316.4,845.2,312.4,845.2,312.4 z"
}));

var _ref27 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#17"
});

var _ref28 = /*#__PURE__*/React.createElement("title", null, "Shape 15");

var _ref29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 20,
  d: "M967.6,377.5 C995,377.6,1009.6,394.5,1009.6,412.7 C1009.6,435.3,990.7,441.8,961.1,441.8 C941.9,441.8,924.9,438.4,913.3,435 C915.4,400.8,940.3,377.4,967.6,377.5 M1023.1,481.8 C1020.3,481.8,1018.2,483,1016.4,484.6 C1004.8,495.3,990.4,502.9,970.9,502.9 C943.7,502.9,918.6,486.2,914,453.9 C928.1,457.9,942.9,460.7,963.1,460.7 C1007.4,460.7,1033.6,443.5,1033.6,412.8 C1033.6,387.7,1011,358.4,967.3,358.4 C923.6,358.4,891.5,395.1,891.5,440.6 C891.5,440.8,891.5,441,891.5,441.2 C891.5,490.1,927,523.4,970.3,523.4 C997.2,523.4,1014.9,513.9,1029.9,499.5 C1032.3,497.4,1033.6,494.6,1033.6,491.8 C1033.5,486.4,1028.9,481.8,1023.1,481.8"
}));

var _ref30 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#19"
});

var _ref31 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref32 = /*#__PURE__*/React.createElement("title", null, "Shape 19");

var _ref33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 23,
  d: "M630.5,152.2 C630.2,151.4,630,150.5,630,149.7 C630,146.1,633.1,143.3,636.7,143.3 C639.9,143.3,642.3,145.3,643.2,148.1 C648.9,165.167,654.6,182.233,660.3,199.3 C665.9,182.3,671.5,165.3,677.1,148.3 C678.2,145.2,680.4,143,683.7,143 C684.033,143,684.367,143,684.7,143 C688,143,690.3,145.1,691.3,148.3 C696.9,165.3,702.5,182.3,708.1,199.3 C713.8,182.2,719.5,165.1,725.2,148 C726.2,145.4,728.4,143.3,731.6,143.3 C735.1,143.3,738.1,146,738.1,149.5 C738.1,150.4,737.8,151.4,737.4,152.1 C730.067,172.667,722.733,193.233,715.4,213.8 C714.2,217.1,711.8,219.3,708.6,219.3 C708.167,219.3,707.733,219.3,707.3,219.3 C704.1,219.3,701.7,217.3,700.6,213.8 C695.067,197.6,689.533,181.4,684,165.2 C678.433,181.4,672.867,197.6,667.3,213.8 C666.1,217.2,663.7,219.3,660.5,219.3 C660.067,219.3,659.633,219.3,659.2,219.3 C656,219.3,653.6,217.3,652.4,213.8 C652.4,213.8,630.5,152.2,630.5,152.2 z"
}));

var _ref34 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#22"
});

var _ref35 = /*#__PURE__*/React.createElement("title", null, "Shape 20");

var _ref36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 25,
  d: "M752.9,149.8 C752.9,146.2,755.8,143.3,759.5,143.3 C763.1,143.3,766,146.2,766,149.8 C766,170.667,766,191.533,766,212.4 C766,216,763.1,218.9,759.5,218.9 C755.8,218.9,752.9,216,752.9,212.4 C752.9,212.4,752.9,149.8,752.9,149.8 z"
}));

var _ref37 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#24"
});

var _ref38 = /*#__PURE__*/React.createElement("title", null, "Shape 21");

var _ref39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 27,
  d: "M802.1,155.9 C796.067,155.9,790.033,155.9,784,155.9 C780.6,155.9,778,153.2,778,149.9 C778,146.6,780.6,143.9,784,143.9 C800.5,143.9,817,143.9,833.5,143.9 C836.8,143.9,839.4,146.6,839.4,149.9 C839.4,153.2,836.8,155.9,833.5,155.9 C827.433,155.9,821.367,155.9,815.3,155.9 C815.3,174.7,815.3,193.5,815.3,212.3 C815.3,215.9,812.3,218.8,808.7,218.8 C805.1,218.8,802.1,215.9,802.1,212.3 C802.1,212.3,802.1,155.9,802.1,155.9 C802.1,155.9,802.1,155.9,802.1,155.9 z"
}));

var _ref40 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#26"
});

var _ref41 = /*#__PURE__*/React.createElement("title", null, "Shape 22");

var _ref42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 29,
  d: "M852,149.8 C852,146.2,854.9,143.3,858.6,143.3 C862.2,143.3,865.1,146.2,865.1,149.8 C865.1,158.133,865.1,166.467,865.1,174.8 C876.933,174.8,888.767,174.8,900.6,174.8 C900.6,166.467,900.6,158.133,900.6,149.8 C900.6,146.2,903.5,143.3,907.1,143.3 C910.8,143.3,913.7,146.2,913.7,149.8 C913.7,170.667,913.7,191.533,913.7,212.4 C913.7,216,910.8,218.9,907.1,218.9 C903.5,218.9,900.6,216,900.6,212.4 C900.6,212.4,900.6,187,900.6,187 C888.767,187,876.933,187,865.1,187 C865.1,195.467,865.1,203.933,865.1,212.4 C865.1,216,862.2,218.9,858.6,218.9 C854.9,218.9,852,216,852,212.4 C852,212.4,852,149.8,852,149.8 z"
}));

var _ref43 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#28"
});

var _ref44 = /*#__PURE__*/React.createElement("clipPath", {
  id: 31
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#30"
}), /*#__PURE__*/React.createElement("path", {
  id: 30,
  d: "M164.401,297.918 C164.401,297.918,420.832,297.918,420.832,297.918 C420.832,297.918,420.832,525.516,420.832,525.516 C420.832,525.516,164.401,525.516,164.401,525.516 C164.401,525.516,164.401,297.918,164.401,297.918 z"
}));

var _ref45 = /*#__PURE__*/React.createElement("title", null, "ClipGroup");

var _ref46 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref47 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref48 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref49 = /*#__PURE__*/React.createElement("title", null, "Shape 24");

var _ref50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 37,
  d: "M342.192,332.478 C331.484,320.606,309.634,308.27,276.787,308.958"
}));

var _ref51 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#36"
});

var _ref52 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref53 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref54 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref55 = /*#__PURE__*/React.createElement("title", null, "Shape 25");

var _ref56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 42,
  d: "M175.45,413.625 C174.637,357.135,222.686,309.69,276.975,309"
}));

var _ref57 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#41"
});

var _ref58 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref59 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref60 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref61 = /*#__PURE__*/React.createElement("title", null, "Shape 26");

var _ref62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 47,
  d: "M350.347,325.087 C359.022,335.026,346.344,350.434,334.004,339.814 C334.004,339.814,333.989,325.122,333.989,325.122 C333.989,325.122,350.349,325.092,350.349,325.092 C350.349,325.092,350.347,325.087,350.347,325.087 z"
}));

var _ref63 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#46"
});

var _ref64 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref65 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref66 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref67 = /*#__PURE__*/React.createElement("title", null, "Shape 27");

var _ref68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 52,
  d: "M281.075,373.008 C303.114,373.008,320.981,390.874,320.981,412.914 C320.981,434.953,303.114,452.819,281.075,452.819 C259.036,452.819,241.17,434.953,241.17,412.914 C241.17,390.874,259.036,373.008,281.075,373.008 z"
}));

var _ref69 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#51"
});

var _ref70 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref71 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref72 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref73 = /*#__PURE__*/React.createElement("title", null, "Shape 28");

var _ref74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 57,
  d: "M267.128,351.886 C267.128,351.886,294.508,351.886,294.508,351.886 C294.508,351.886,294.508,371.34,294.508,371.34 C294.508,371.34,267.128,371.34,267.128,371.34 C267.128,371.34,267.128,351.886,267.128,351.886 z"
}));

var _ref75 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#56"
});

var _ref76 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref77 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref78 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref79 = /*#__PURE__*/React.createElement("title", null, "Shape 29");

var _ref80 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 62,
  d: "M267.777,454.934 C267.777,454.934,295.158,454.934,295.158,454.934 C295.158,454.934,295.158,474.389,295.158,474.389 C295.158,474.389,267.777,474.389,267.777,474.389 C267.777,474.389,267.777,454.934,267.777,454.934 z"
}));

var _ref81 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#61"
});

var _ref82 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref83 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref84 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref85 = /*#__PURE__*/React.createElement("title", null, "Shape 30");

var _ref86 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 67,
  d: "M224.093,381.14 C224.093,381.14,243.455,361.779,243.455,361.779 C243.455,361.779,257.211,375.535,257.211,375.535 C257.211,375.535,237.85,394.896,237.85,394.896 C237.85,394.896,224.093,381.14,224.093,381.14 z"
}));

var _ref87 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#66"
});

var _ref88 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref89 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref90 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref91 = /*#__PURE__*/React.createElement("title", null, "Shape 31");

var _ref92 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 72,
  d: "M245.744,464.782 C245.744,464.782,226.383,445.42,226.383,445.42 C226.383,445.42,240.139,431.664,240.139,431.664 C240.139,431.664,259.5,451.025,259.5,451.025 C259.5,451.025,245.744,464.782,245.744,464.782 z"
}));

var _ref93 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#71"
});

var _ref94 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref95 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref96 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref97 = /*#__PURE__*/React.createElement("title", null, "Shape 32");

var _ref98 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 77,
  d: "M337.879,380.481 C337.879,380.481,318.518,361.12,318.518,361.12 C318.518,361.12,304.76,374.876,304.76,374.876 C304.76,374.876,324.123,394.239,324.123,394.239 C324.123,394.239,337.879,380.481,337.879,380.481 z"
}));

var _ref99 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#76"
});

var _ref100 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref101 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref102 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref103 = /*#__PURE__*/React.createElement("title", null, "Shape 33");

var _ref104 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 82,
  d: "M316.227,464.124 C316.227,464.124,335.588,444.762,335.588,444.762 C335.588,444.762,321.832,431.006,321.832,431.006 C321.832,431.006,302.471,450.367,302.471,450.367 C302.471,450.367,316.227,464.124,316.227,464.124 z"
}));

var _ref105 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#81"
});

var _ref106 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref107 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref108 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref109 = /*#__PURE__*/React.createElement("title", null, "Shape 34");

var _ref110 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 87,
  d: "M341.316,490.852 C330.608,502.724,308.757,515.061,275.91,514.373"
}));

var _ref111 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#86"
});

var _ref112 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref113 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref114 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref115 = /*#__PURE__*/React.createElement("title", null, "Shape 35");

var _ref116 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 92,
  d: "M175.412,413.555 C175.979,468.527,221.81,513.815,276.098,514.505"
}));

var _ref117 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#91"
});

var _ref118 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref119 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref120 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref121 = /*#__PURE__*/React.createElement("title", null, "Shape 36");

var _ref122 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 97,
  d: "M349.469,498.243 C358.144,488.305,345.467,472.897,333.127,483.517 C333.127,483.517,333.112,498.208,333.112,498.208 C333.112,498.208,349.471,498.237,349.471,498.237 C349.471,498.237,349.469,498.243,349.469,498.243 z"
}));

var _ref123 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#96"
});

var _ref124 = /*#__PURE__*/React.createElement("clipPath", {
  id: 99
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#98"
}), /*#__PURE__*/React.createElement("path", {
  id: 98,
  d: "M164.401,297.918 C164.401,297.918,420.832,297.918,420.832,297.918 C420.832,297.918,420.832,525.516,420.832,525.516 C420.832,525.516,164.401,525.516,164.401,525.516 C164.401,525.516,164.401,297.918,164.401,297.918 z"
}));

var _ref125 = /*#__PURE__*/React.createElement("title", null, "Shape 21");

var _ref126 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 102,
  d: "M375.113,155.721 C369.08,155.721,363.047,155.721,357.013,155.721 C353.613,155.721,351.013,153.021,351.013,149.721 C351.013,146.421,353.613,143.721,357.013,143.721 C373.513,143.721,390.013,143.721,406.513,143.721 C409.813,143.721,412.413,146.421,412.413,149.721 C412.413,153.021,409.813,155.721,406.513,155.721 C400.447,155.721,394.38,155.721,388.313,155.721 C388.313,174.521,388.313,193.321,388.313,212.121 C388.313,215.721,385.313,218.621,381.713,218.621 C378.113,218.621,375.113,215.721,375.113,212.121 C375.113,212.121,375.113,155.721,375.113,155.721 C375.113,155.721,375.113,155.721,375.113,155.721 z"
}));

var _ref127 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#101"
});

var _ref128 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref129 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 104,
  d: "M457.765,149.051 C457.765,149.051,426.971,148.986,426.971,148.986 C426.971,148.986,426.949,179.853,426.949,179.853 C426.949,179.853,426.927,211.824,426.927,211.824 C426.927,211.824,457.464,211.576,457.464,211.576"
}));

var _ref130 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#103"
});

var _ref131 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref132 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 106,
  d: "M452.081,180.174 C452.081,180.174,427.304,180.52,427.304,180.52"
}));

var _ref133 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#105"
});

var _ref134 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref135 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 108,
  d: "M517.392,163.381 C517.714,143.552,478.334,144.222,478.113,167.567 C477.848,195.623,516.91,172.797,516.559,194.048 C516.085,222.767,478.359,214.739,478.609,200.567"
}));

var _ref136 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#107"
});

var _ref137 = /*#__PURE__*/React.createElement("title", null, "Shape 21");

var _ref138 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: 110,
  d: "M556.097,158.472 C550.064,158.472,544.031,158.472,537.997,158.472 C534.597,158.472,531.997,155.772,531.997,152.472 C531.997,149.172,534.597,146.472,537.997,146.472 C554.497,146.472,570.997,146.472,587.497,146.472 C590.797,146.472,593.397,149.172,593.397,152.472 C593.397,155.772,590.797,158.472,587.497,158.472 C581.431,158.472,575.364,158.472,569.297,158.472 C569.297,177.272,569.297,196.072,569.297,214.872 C569.297,218.472,566.297,221.372,562.697,221.372 C559.097,221.372,556.097,218.472,556.097,214.872 C556.097,214.872,556.097,158.472,556.097,158.472 C556.097,158.472,556.097,158.472,556.097,158.472 z"
}));

var _ref139 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#109"
});

var SvgTestwithcharlie = function SvgTestwithcharlie(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "164.401pt",
    y: "143pt",
    width: "956.099pt",
    height: "382.516pt",
    viewBox: "164.401 143 956.099 382.516",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: 1
  }, _ref2, /*#__PURE__*/React.createElement("g", {
    id: 2
  }, _ref3, /*#__PURE__*/React.createElement("defs", null, _ref4, /*#__PURE__*/React.createElement("g", {
    id: 3
  }, _ref5, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4",
    style: {
      fill: "#d1f125",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref6, /*#__PURE__*/React.createElement("defs", null, _ref7, /*#__PURE__*/React.createElement("g", {
    id: 5
  }, _ref8, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6",
    style: {
      fill: "#d1f125",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref9, /*#__PURE__*/React.createElement("defs", null, _ref10, /*#__PURE__*/React.createElement("g", {
    id: 7
  }, _ref11, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8",
    style: {
      fill: "#d1f125",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref12, /*#__PURE__*/React.createElement("defs", null, _ref13, /*#__PURE__*/React.createElement("g", {
    id: 9
  }, _ref14, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#10",
    style: {
      fill: "#d1f125",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref15, /*#__PURE__*/React.createElement("defs", null, _ref16, /*#__PURE__*/React.createElement("g", {
    id: 11
  }, _ref17, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#12",
    style: {
      fill: "#d1f125",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref18, /*#__PURE__*/React.createElement("defs", null, _ref19, /*#__PURE__*/React.createElement("g", {
    id: 13
  }, _ref20, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#14",
    style: {
      fill: "#d1f125",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref21, /*#__PURE__*/React.createElement("defs", null, _ref22, /*#__PURE__*/React.createElement("g", {
    id: 15
  }, _ref23, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#16",
    style: {
      fill: "#d1f125",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref24, /*#__PURE__*/React.createElement("defs", null, _ref25, /*#__PURE__*/React.createElement("g", {
    id: 17
  }, _ref26, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#18",
    style: {
      fill: "#d1f125",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref27, /*#__PURE__*/React.createElement("defs", null, _ref28, /*#__PURE__*/React.createElement("g", {
    id: 19
  }, _ref29, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#20",
    style: {
      fill: "#d1f125",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref30), /*#__PURE__*/React.createElement("g", {
    id: 21
  }, _ref31, /*#__PURE__*/React.createElement("defs", null, _ref32, /*#__PURE__*/React.createElement("g", {
    id: 22
  }, _ref33, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#23",
    style: {
      fill: "#d1f125",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref34, /*#__PURE__*/React.createElement("defs", null, _ref35, /*#__PURE__*/React.createElement("g", {
    id: 24
  }, _ref36, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#25",
    style: {
      fill: "#d1f125",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref37, /*#__PURE__*/React.createElement("defs", null, _ref38, /*#__PURE__*/React.createElement("g", {
    id: 26
  }, _ref39, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#27",
    style: {
      fill: "#d1f125",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref40, /*#__PURE__*/React.createElement("defs", null, _ref41, /*#__PURE__*/React.createElement("g", {
    id: 28
  }, _ref42, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#29",
    style: {
      fill: "#d1f125",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref43)), _ref44, /*#__PURE__*/React.createElement("g", {
    id: 32,
    style: {
      clipPath: "url(#31)"
    }
  }, _ref45, /*#__PURE__*/React.createElement("g", {
    id: 33
  }, _ref46, /*#__PURE__*/React.createElement("g", {
    id: 34
  }, _ref47, /*#__PURE__*/React.createElement("g", {
    id: 35
  }, _ref48, /*#__PURE__*/React.createElement("defs", null, _ref49, /*#__PURE__*/React.createElement("g", {
    id: 36
  }, _ref50, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#37",
    style: {
      fill: "none",
      opacity: 1,
      stroke: "#d1f024",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 20
    }
  }))), _ref51))), /*#__PURE__*/React.createElement("g", {
    id: 38
  }, _ref52, /*#__PURE__*/React.createElement("g", {
    id: 39
  }, _ref53, /*#__PURE__*/React.createElement("g", {
    id: 40
  }, _ref54, /*#__PURE__*/React.createElement("defs", null, _ref55, /*#__PURE__*/React.createElement("g", {
    id: 41
  }, _ref56, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#42",
    style: {
      fill: "none",
      opacity: 1,
      stroke: "#d1f024",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 20
    }
  }))), _ref57))), /*#__PURE__*/React.createElement("g", {
    id: 43
  }, _ref58, /*#__PURE__*/React.createElement("g", {
    id: 44
  }, _ref59, /*#__PURE__*/React.createElement("g", {
    id: 45
  }, _ref60, /*#__PURE__*/React.createElement("defs", null, _ref61, /*#__PURE__*/React.createElement("g", {
    id: 46
  }, _ref62, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#47",
    style: {
      fill: "#d1f024",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref63))), /*#__PURE__*/React.createElement("g", {
    id: 48
  }, _ref64, /*#__PURE__*/React.createElement("g", {
    id: 49
  }, _ref65, /*#__PURE__*/React.createElement("g", {
    id: 50
  }, _ref66, /*#__PURE__*/React.createElement("defs", null, _ref67, /*#__PURE__*/React.createElement("g", {
    id: 51
  }, _ref68, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#52",
    style: {
      fill: "none",
      opacity: 1,
      stroke: "#d1f123",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 20
    }
  }))), _ref69))), /*#__PURE__*/React.createElement("g", {
    id: 53
  }, _ref70, /*#__PURE__*/React.createElement("g", {
    id: 54
  }, _ref71, /*#__PURE__*/React.createElement("g", {
    id: 55
  }, _ref72, /*#__PURE__*/React.createElement("defs", null, _ref73, /*#__PURE__*/React.createElement("g", {
    id: 56
  }, _ref74, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#57",
    style: {
      fill: "#d1f123",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref75))), /*#__PURE__*/React.createElement("g", {
    id: 58
  }, _ref76, /*#__PURE__*/React.createElement("g", {
    id: 59
  }, _ref77, /*#__PURE__*/React.createElement("g", {
    id: 60
  }, _ref78, /*#__PURE__*/React.createElement("defs", null, _ref79, /*#__PURE__*/React.createElement("g", {
    id: 61
  }, _ref80, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#62",
    style: {
      fill: "#d1f123",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref81))), /*#__PURE__*/React.createElement("g", {
    id: 63
  }, _ref82, /*#__PURE__*/React.createElement("g", {
    id: 64
  }, _ref83, /*#__PURE__*/React.createElement("g", {
    id: 65
  }, _ref84, /*#__PURE__*/React.createElement("defs", null, _ref85, /*#__PURE__*/React.createElement("g", {
    id: 66
  }, _ref86, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#67",
    style: {
      fill: "#d1f123",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref87))), /*#__PURE__*/React.createElement("g", {
    id: 68
  }, _ref88, /*#__PURE__*/React.createElement("g", {
    id: 69
  }, _ref89, /*#__PURE__*/React.createElement("g", {
    id: 70
  }, _ref90, /*#__PURE__*/React.createElement("defs", null, _ref91, /*#__PURE__*/React.createElement("g", {
    id: 71
  }, _ref92, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#72",
    style: {
      fill: "#d1f123",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref93))), /*#__PURE__*/React.createElement("g", {
    id: 73
  }, _ref94, /*#__PURE__*/React.createElement("g", {
    id: 74
  }, _ref95, /*#__PURE__*/React.createElement("g", {
    id: 75
  }, _ref96, /*#__PURE__*/React.createElement("defs", null, _ref97, /*#__PURE__*/React.createElement("g", {
    id: 76
  }, _ref98, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#77",
    style: {
      fill: "#d1f123",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref99))), /*#__PURE__*/React.createElement("g", {
    id: 78
  }, _ref100, /*#__PURE__*/React.createElement("g", {
    id: 79
  }, _ref101, /*#__PURE__*/React.createElement("g", {
    id: 80
  }, _ref102, /*#__PURE__*/React.createElement("defs", null, _ref103, /*#__PURE__*/React.createElement("g", {
    id: 81
  }, _ref104, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#82",
    style: {
      fill: "#d1f123",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref105))), /*#__PURE__*/React.createElement("g", {
    id: 83
  }, _ref106, /*#__PURE__*/React.createElement("g", {
    id: 84
  }, _ref107, /*#__PURE__*/React.createElement("g", {
    id: 85
  }, _ref108, /*#__PURE__*/React.createElement("defs", null, _ref109, /*#__PURE__*/React.createElement("g", {
    id: 86
  }, _ref110, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#87",
    style: {
      fill: "none",
      opacity: 1,
      stroke: "#d1f024",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 20
    }
  }))), _ref111))), /*#__PURE__*/React.createElement("g", {
    id: 88
  }, _ref112, /*#__PURE__*/React.createElement("g", {
    id: 89
  }, _ref113, /*#__PURE__*/React.createElement("g", {
    id: 90
  }, _ref114, /*#__PURE__*/React.createElement("defs", null, _ref115, /*#__PURE__*/React.createElement("g", {
    id: 91
  }, _ref116, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#92",
    style: {
      fill: "none",
      opacity: 1,
      stroke: "#d1f024",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 20
    }
  }))), _ref117))), /*#__PURE__*/React.createElement("g", {
    id: 93
  }, _ref118, /*#__PURE__*/React.createElement("g", {
    id: 94
  }, _ref119, /*#__PURE__*/React.createElement("g", {
    id: 95
  }, _ref120, /*#__PURE__*/React.createElement("defs", null, _ref121, /*#__PURE__*/React.createElement("g", {
    id: 96
  }, _ref122, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#97",
    style: {
      fill: "#d1f024",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref123)))), _ref124, /*#__PURE__*/React.createElement("g", {
    id: 100,
    style: {
      clipPath: "url(#99)"
    }
  }), /*#__PURE__*/React.createElement("defs", null, _ref125, /*#__PURE__*/React.createElement("g", {
    id: 101
  }, _ref126, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#102",
    style: {
      fill: "#d1f024",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref127, /*#__PURE__*/React.createElement("defs", null, _ref128, /*#__PURE__*/React.createElement("g", {
    id: 103
  }, _ref129, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#104",
    style: {
      fill: "none",
      opacity: 1,
      stroke: "#d1f123",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 11
    }
  }))), _ref130, /*#__PURE__*/React.createElement("defs", null, _ref131, /*#__PURE__*/React.createElement("g", {
    id: 105
  }, _ref132, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#106",
    style: {
      fill: "none",
      opacity: 1,
      stroke: "#d1f123",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 11
    }
  }))), _ref133, /*#__PURE__*/React.createElement("defs", null, _ref134, /*#__PURE__*/React.createElement("g", {
    id: 107
  }, _ref135, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#108",
    style: {
      fill: "none",
      opacity: 1,
      stroke: "#d1f123",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 11
    }
  }))), _ref136, /*#__PURE__*/React.createElement("defs", null, _ref137, /*#__PURE__*/React.createElement("g", {
    id: 109
  }, _ref138, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#110",
    style: {
      fill: "#d1f024",
      fillOpacity: 1,
      fillRule: "evenodd",
      opacity: 1,
      stroke: "none"
    }
  }))), _ref139);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTestwithcharlie, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/testwithcharlie.4ab04c67.svg";
export { ForwardRef as ReactComponent };